import { Suspense } from 'react';

import { ROUTE } from 'pages/public/Routes';
import { Loading } from 'pages';
import { Route, Routes } from 'react-router-dom';
import { ErrorPage } from 'pages/public/PublicRoutes';

import _Login from './Login';
import Sso from './SSO';

const LoginRoutes: ROUTE[] = [
  {
    index: true,
    path: '/',
    element: () => <_Login />,
  },
  {
    path: '/sso',
    element: () => <Sso />,
  },
];

export const Login = () => (
  <Suspense fallback={<Loading />}>
    <Routes>
      {LoginRoutes.map(({ path, element, index }) => (
        <Route
          key={Math.random()}
          path={path}
          index={Boolean(index)}
          element={element?.()}
        />
      ))}
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  </Suspense>
);
